import { useEffect } from "react";

import { Button, Icon_CheckmarkFilled60 } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import WarningIcon from "../../assets/images/warning-icon.svg";
import useNavigation from "../../hooks/navigation";
import DownloadSection from "../DownloadSection/DownloadSection";
import Heading from "../Heading/Heading";
import { NewZendeskTicketLink } from "../NewZendeskTicketLink/NewZendeskTicketLink";

import style from "./VoucherClaimResult.module.css";

export enum VoucherClaimRequestResult {
  Success = "SUCCESS",
  MultipleSubscriptionsError = "MULTIPLE_ACTIVE_SUBSCRIPTIONS",
  InvalidVoucherError = "INVALID_VOUCHER",
  UnknownError = "UNKNOWN_ERROR",
}

interface VoucherClaimResultProps {
  result: VoucherClaimRequestResult;
  isVerificationError?: boolean;
}

const VoucherClaimResult = (props: VoucherClaimResultProps) => {
  const navigation = useNavigation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goToProfile = () => {
    navigation.goToProfile(["voucherId"]);
  };
  return (
    <div className={style.wrapperContainer}>
      <div className={style.wrapperCenter}>
        {props.result === VoucherClaimRequestResult.Success && (
          <>
            <Icon_CheckmarkFilled60
              className={classNames(style.icon, style.checkIcon)}
              role="img"
            />
            <Heading type="h1" className={style.header}>
              Welcome to Shapr3D!
              <br />
              Your Pro subscription has been activated
            </Heading>

            <DownloadSection />
          </>
        )}

        {props.result === VoucherClaimRequestResult.InvalidVoucherError && (
          <>
            <img src={WarningIcon} className={style.icon} />
            <Heading type="h1">Sorry, this voucher is invalid or already expired</Heading>
            {!props.isVerificationError && (
              <div style={{ padding: "50px" }}>
                <Button onClick={goToProfile}>View your subscription</Button>
              </div>
            )}
          </>
        )}
        {props.result === VoucherClaimRequestResult.MultipleSubscriptionsError && (
          <>
            <img src={WarningIcon} className={style.icon} />
            <Heading type="h1">
              This voucher is only valid for accounts that do not have an active subscription
            </Heading>
            <div style={{ padding: "50px" }}>
              <Button onClick={goToProfile}>View your subscription</Button>
            </div>
          </>
        )}
        {props.result === VoucherClaimRequestResult.UnknownError && (
          <>
            <img src={WarningIcon} className={style.icon} />
            <Heading type="h1">There was an error activating your subscription</Heading>
            <div style={{ padding: "20px" }}>
              Please refresh the page to try again, or submit a{" "}
              <NewZendeskTicketLink>support ticket</NewZendeskTicketLink>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VoucherClaimResult;
